import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import moment from "moment-timezone";
import useHeader from "../../hooks/useHeader";
import useFunctions from "../../hooks/functions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  exploreMenuRequest,
  getRestaurantMenuDetails,
  setSelectedDeliveryAddress,
  setSelectedDeliveryType,
  setSelectedRestaurantTab,
  toggleClick,
  viewDeliveryAddressRequest,

} from "../../common/features/restaurant/restaurantAction";
import {
  cartItemRequest,
  toggleCartView,
  setSelectedDate,
  setTipAdded,
  setDeliveryOrderDistance,
  replacecartItems,
  setSelectedTimeSlot,
  reservatonMenuApiCall,
  clearNotip,
  clearCustomtip,
  clearCustomTipvalue,
  isScheduleOrderPlaceOrder,
  setNotip,
  routeToLogin,
  couponClicked,
  
} from "../../common/features/cart/cartActions";
import accountsBack from "../../common/assets/svg/accountsBack.svg";
import calendar from "../../common/assets/svg/HeaderCalender.svg";
// import Map from "../../common/assets/svg/header-map-pin.svg";
import { ReactComponent as Maps } from "../../common/assets/svg/header-map-pin.svg";

import { ReactComponent as CartIcon } from "../../common/assets/svg/cartIcon.svg";
import userIcon from "../../common/assets/svg/profile-user.svg";
import checkOutBell from "../../common/assets/svg/checkOutBell.svg";
import { ReactComponent as ActiveUser } from "./../../common/assets/svg/activeUser.svg";

import { useLocation, useNavigate, useParams } from "react-router";
import Signupnew from "../Signupnew/siginInContainer";
import SwitchingorderType from "../SwitchingorderType/SwitchingorderType";
import { RestaurantMenuItem } from "../../common/features/restaurant/restaurantModels";
import PickDateSelectionDesktop from "../../pages/checkOut/PickDateSelectionDesktop";
import { cleanedPath, formatDate } from "../../common/utils";
import { ReactComponent as BackBtn } from "../../common/assets/svg/Backbtn.svg";
import { ReactComponent as HomeIcon } from "../../common/assets/svg/homePage.svg";
import "./style.scss";
import DeliveryDetails from "../../components/DeliveryDetailsInCheckot/DeliverDetails";
import { IAddressDetail } from "../../common/features/location/locationModels";
import { DeliveryChargeRequestBody } from "../../common/features/delivery/DeliveryModels";
import { getDeliveryChargeInitiated } from "../../common/features/delivery/DeliveryActions";
import { showErrorToast, showErrorToastDesktop } from "../../common/utils/toastUtils";
import { ReactComponent as CancelIcon } from "../../common/assets/svg/cancelIconnew.svg";
import { getAsapTime, getCurrentTimeASAP, getCurrentTimeByTimezone, isAsapTime } from "../../common/utils/date-time-helper-utils";
import { getDistanceBtwResUser } from "../../common/features/order/orderAPI";
import { AxiosResponse } from "axios";
import { decryptJson } from "../../common/utils/react-ec-utils";
import { Helmet } from "react-helmet-async";
import "./style.scss"
import { useIsEventOrders } from "../../common/features/selectors";
import useRedirect from "../../hooks/useRedirct";
import { USER_DETAILS, USER_ID } from "../../common/constants";
import { getCookie } from "../../helper/cookieHelper";
import { setSignupPopup as setSignupPopupAction } from "../../common/features/navigation/navigationActions";


const DesktopHeader = ({
  setPaymentStatus,
  setSignupPopup,
  setCardDelete,
  signupPopup,
  Switch,
  currentOrdertypeDetails,
  setCurrentOrdertypeDetails,
  menuType,
  handleBack,
  NavigateProfile,
  GotoProfile,
  isAccountPage,
  selectedTab,
  notShowBack,
  TrackingPage,
  setShowMenuDrawer,
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const redirect=useRedirect()

  const {
    isCart,
    goBack,
    getImageURL,
    restaurantDetails,
    selectedDeliveryType,
    setCartItem,
    CartItemIds,
    // customerId,
    basePath,
    setSwitchingOrderType,
    tableId,
    orderDetails,
    orderInfo,
    slugFromLocalStorage,
    handleLogoutclick,
    cdOrdersItems,
    showLogout,
    setShowLogout,
    switchingOrderType,
    cartData,
  } = useHeader({
    handleBack,
    currentOrdertypeDetails,
    menuType,
    setCurrentOrdertypeDetails,
  });

  const customerId = getCookie(USER_ID) || '';
    const userDetailsFromCookie = getCookie(USER_DETAILS) || {};
  const [selectedPop, setSelectedPop] = useState("");
  const location = useLocation();
  const isEventDate = useSelector((state: any) => state.cart.isEventDate)
  const isEventOrder = localStorage.getItem('isEventOrder')
  // const eventDate = useSelector((state: any) => state.cart.eventDate)
  const isCartViewVisible = useSelector((state: any) => state.cart.isCartViewVisible);
  const selectedDeliveryAddress = useSelector((state: any) => state?.restaurant?.selectedDeliveryAddress);
  const [orderType, setOrderType] = useState(isEventDate ? "Pickup" : selectedDeliveryType);
  const [dishes, setDishes] = useState<RestaurantMenuItem[]>([]);
  const [dropLocationError, setdropLocationError] = useState(false);
  const [distanceBtwResAdd, setdistanceBtwResAdd] = useState<any>();
  const exploreMenu = useSelector(
    (state: any) => state.restaurant.exploreMenu?.menu
  );
  const eventName = useSelector((state: any) => state.persistedState?.eventDate)  
 
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile);
  let { itemName, eventDate } = useParams<any>();
  const DeliveryAddress = useSelector(
    (state: any) => state?.restaurant?.DeliveryAddress
  );
  const orderDetailsFromRedux = useSelector((state: any) => state.order.currentOrderDetail);
  const totals = useSelector((state: any) => state.cart.totalDetails);
  const [addresses, setAddresses] = useState<IAddressDetail[]>([]);
  const [selectedAddresses, setSelectedAddress] = useState("");
  const [address, setAddress] = useState<Partial<IAddressDetail>>({
    addressLine1: "",
    apartment: "",
    state: "",
    city: "",
    zipcode: "",
    addressTag: "",
    deliveryInstructions: "",
  });

  const [showToast, setShowToast] = useState(false);
  const [currentAddress, setCurrentAddress] = useState<any>({});

  const cartRestaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );


  const handleDeliveryFormSubmit = (formData: any) => {
    //TODO:check this
    setAddresses((prev) => [...prev, { ...formData }]);
  };

  const onDeleteAddress = (id: any) => {
    // setAddresses((prev) => prev.filter((value, idx) => idx !== index));
    if (selectedAddresses == id) {
      setSelectedAddress("");
    }
  };

  const handleAddressFieldOnChange = (e: any) => {
    setAddress((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const handelClosePopUp = () => {
    setSelectedPop("");
  };
  const isEventOrders = useIsEventOrders();
  const locationID = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail.id
  );

  const currentLocationBranchList = useSelector((state: any) => state.restaurant.currentRestaurantDetail.branch);

  const currentLocationDetails = useMemo(() => {
    return currentLocationBranchList.filter((branch: any) => {
      return branch.id === cartRestaurantDetails?.id;
    })
  }, [currentLocationBranchList])

  const restaurantLocationDetails = useMemo(() => {
    return currentLocationDetails.length > 0 ? currentLocationDetails[0] : null;
  }, [currentLocationDetails]);

  const orderDetail = useSelector(
    (state: any) => state.order.currentOrderDetail
  );

  const currentLocation = useSelector(
    (state: any) => state.restaurant.currentLocation
  );

  const tipValue = useSelector((state: any) => state.cart.tipValue);
  const tipType = useSelector((state: any) => state.cart.tipType);
  const getDeliveryChargeSuccess = useSelector(
    (state: any) => state.delivery.getDeliveryChargeSuccess
  );
  const getDeliveryChargeFailed = useSelector(
    (state: any) => state.delivery.getDeliveryChargeFailed
  );

  const [shouldNotShowBackbtn, setShouldNotShowBackbtn] = useState(false);

  useEffect(() => {
    const pathname = location.pathname;
    const endsWithPrivacyPolicy = pathname.endsWith("PrivacyPolicy");
    const includesAccountOrPolicies = pathname.includes("account") || pathname.includes("policies");

    if (endsWithPrivacyPolicy && !includesAccountOrPolicies) {
      setShouldNotShowBackbtn(true);
    }

  }, [location.pathname]);

  useEffect(() => {
    if (showToast && !isMobile) {
      if (getDeliveryChargeSuccess) {
        dispatch(setSelectedDeliveryAddress(currentAddress));
        // handleExpandStep(2);
        setShowToast(false)
      }
      if (getDeliveryChargeFailed) {
        if (isMobile) {
          showErrorToast("Unable to deliver to this location !")
        } else {
          showErrorToastDesktop("Unable to deliver to this location !")
        }
        setSelectedAddress("")
        setCurrentAddress({})
        dispatch(setSelectedDeliveryAddress({}));
      }
    }
  }, [getDeliveryChargeSuccess, getDeliveryChargeFailed])

  const selectedRes = restaurantDetails?.branch?.filter(
    (u: any) => u?.id === restaurantDetails?.id
  );

  const isDeliveryOrderForAddress = restaurantDetails?.orderTypes?.some((type: any) => {
    return type?.typeName === slugFromLocalStorage?.menuType && type?.typeGroup === 'S'
  })

  const PickupOrderType = restaurantDetails?.orderTypes?.filter((item: any) => item.typeGroup === "P")
  const DeliveryOrderType = restaurantDetails?.orderTypes?.filter((item: any) => item.typeGroup === "S")

  const DeliveryProvider = restaurantDetails?.locationDeliveryProviders ?? null;

  const paymentAmount = tableId
  ? `${orderDetailsFromRedux?.orderTotal ?? ''}`
  : `${totals?.orderTotals?.find((order: any) => Number(order?.code) === 1)?.value ?? ''}`;


  const onAddressSelect = (address: any) => {
    if (restaurantDetails?.country === 'US') {
      const DeliveryProvider =
        cartRestaurantDetails && cartRestaurantDetails?.locationDeliveryProviders;

      if (address?.id) {
        const payload: DeliveryChargeRequestBody = {
          locationId: locationID,
          pickupDetails: {
            Address: {
              streetAddress1: cartRestaurantDetails.address,
              streetAddress2: "",
              city: cartRestaurantDetails.city,
              state: "",
              pincode: "",
            },
            lat: restaurantLocationDetails?.latitude,
            lng: restaurantLocationDetails?.longitude,
          },
          receiverDetails: {
            // TODO: confirm if its static
            name: "MagilHub Customer",
            phoneNumber: "+16505555555",
          },
          senderDetails: {
            name: cartRestaurantDetails.branchName,
            phoneNumber: cartRestaurantDetails.phoneNumber,
          },
          dropDetails: {
            Address: {
              streetAddress1: address.addressLine1 + ", " + address?.city + ", " + address?.state + ", " + address?.postalCd,
              streetAddress2: address?.apartment,
              city: address?.city,
              state: address?.state,
              pincode: address?.postalCd,
            },
            lat: address?.latitude,
            lng: address.longitude,
          },
          deliveryProviderId: DeliveryProvider?.deliveryProviderId ?? "DOORDASH",
          tip: tipValue,
          orderTotal: paymentAmount,
          emailId: userDetailsFromCookie?.email || "",
          mobileNo: userDetailsFromCookie?.mobilePhone || "",
          ...(selectedDeliveryAddress?.id && { addressId: selectedDeliveryAddress?.id }),
          customerId: getCookie(USER_ID),
        };
        setShowToast(true);
        dispatch(getDeliveryChargeInitiated(payload));
        setSelectedAddress(address);
        setCurrentAddress(address);
      }
    } else {
      const distanceData = selectedRes?.length > 0 && {
        sourceLat: restaurantLocationDetails?.latitude,
        sourceLon: restaurantLocationDetails?.longitude,
        destinationLat: selectedRes[0].latitude,
        destinationLon: selectedRes[0].longitude,
      };
      if (isDeliveryOrderForAddress && DeliveryProvider == null) {
        distanceData &&
          getDistanceBtwResUser(distanceData)
            .then((response: AxiosResponse) => {
              const decryptedData = decryptJson(response.data.encryptedText);
              if (decryptedData === '') {
                setdropLocationError(true);
              } else {
                let res =
                  decryptedData &&
                  decryptedData.distance.length > 0 &&
                  parseFloat(decryptedData.distance[0].split(' ')[0].replace(/,/g, ''));
                if (
                  restaurantDetails.deliveryKMRadius &&
                  res > restaurantDetails.deliveryKMRadius
                ) {
                  setSelectedAddress(address);
                } else {
                  res && dispatch(setDeliveryOrderDistance(res));
                  setdistanceBtwResAdd(res);
                  setCurrentAddress(address);
                  setdropLocationError(true);
                }
              }
            })
            .catch((err: any) => {
              showErrorToastDesktop('Something went wrong')
            });
      }
    }
  };

  const handleTabClick = (tab: string) => {
    dispatch(setSelectedRestaurantTab(tab));
    localStorage?.setItem("selectedTab", tab);
    // if (itemName && tab == "restaurantInfo") {
    //   navigate(-1);
    // }
  };

  const [showSignUpPopup, setShowSignUpPopup] = useState(false);
  const globalShowSignupPopup = useSelector((state: any) => state?.navigation?.showSignupPopup);
  const [isGlobalTriggered, setIsGlobalTriggered] = useState(false);
  const prevGlobalStateRef = useRef(false);

  // Listen to global Redux state for 403/401 errors
  useEffect(() => {
    // Only mark as globally triggered if state changes from false to true (new 403/401)
    if (globalShowSignupPopup && !prevGlobalStateRef.current) {
      setIsGlobalTriggered(true);
    } else if (!globalShowSignupPopup) {
      // When global state becomes false, reset the flag
      setIsGlobalTriggered(false);
      setShowSignUpPopup(false);
    }
    prevGlobalStateRef.current = globalShowSignupPopup;
  }, [globalShowSignupPopup]);

  const [isAsapVisible, setIsAsapVisible] = useState(false);
  const openLoginPopUp = useSelector((state: any) => state.cart.openLoginPopUp)
  
  useEffect(() => {
    if(openLoginPopUp && !showSignUpPopup){
      setShowSignUpPopup(true)
    }
  }, [openLoginPopUp])

  console.log({showSignUpPopup}, {openLoginPopUp})

  const toggleCart = () => { 
    if (cartData?.length > 0) {
         dispatch(couponClicked(false));
      dispatch(toggleCartView(!isCartViewVisible));
    
    } else {
      dispatch(toggleCartView(false));

    }
  };

  useEffect(() => {
    if (cartData?.length === 0 && !isMobile && !tableId) {
      dispatch(setTipAdded(false))


      dispatch(clearNotip());
      dispatch(clearCustomtip());
      dispatch(clearCustomTipvalue());
    }
  }, [cartData])

  const { groupMenuExploreItems } = useFunctions();

  const seletedTab = useSelector(
    (state: any) => state.restaurant.selectedRestaurantTab
  );

  const cartItems = useSelector((state: any) => state?.cart?.cart?.items)

  useEffect(() => {
    if (!exploreMenu && !isMobile && restaurantDetails?.id && dishes?.length < 1 && menuType) {
      dispatch(
        exploreMenuRequest({
          locationId: restaurantDetails?.id,
          menuType: menuType,
        })
      );
    }
  }, [restaurantDetails.id, menuType, slugFromLocalStorage?.location]);

  useEffect(() => {
    if (exploreMenu && exploreMenu?.length > 0) {
      setDishes([...exploreMenu]);
    }
  }, [exploreMenu]);
  const disabledServices = restaurantDetails.disabledServices;
  const isServiceEnabled = useCallback(
    (typeGroup: string) => {
      if (disabledServices && typeGroup == "checkIn") {
        if (!disabledServices.onlineCheckIn) {
          return disabledServices.onlineCheckIn == 0;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    [disabledServices]
  );
  const commonSuccess = (menuItems: RestaurantMenuItem[]) => {
    const menuItemMap = new Map(menuItems.map(item => [item.itemId, item]));

    const updatedCartItems = cartItems.map((cartItem: any) => {
      const matchedMenuItem = menuItemMap.get(cartItem.itemId);
      if (!matchedMenuItem) return cartItem;

      const validOptionIds = new Set(
        (matchedMenuItem.customization || []).map((opt: any) => opt.modifierOptionId)
      );

      const filteredOptions = (cartItem.options || []).filter(
        (opt: any) => validOptionIds.has(opt.modifierOptionId)
      );

      const optionTotal = filteredOptions.reduce((sum: number, opt: any) => {
        return sum + (typeof opt.price === 'number' ? opt.price : 0);
      }, 0);

      const newPrice = parseFloat(matchedMenuItem.price);
      const quantity = parseFloat(cartItem.quantity);
      const newSubTotal = (((newPrice + optionTotal)) * quantity).toFixed(2);

      return {
        ...cartItem,
        price: newPrice,
        subTotal: newSubTotal,
        options: filteredOptions,
      };
    });
    dispatch(replacecartItems(updatedCartItems))
  }

  const TogglleClick = (type: any) => {
    dispatch(setSelectedDeliveryType(type));
    dispatch(toggleClick());
    if(menuType?.toLowerCase() !== type?.toLowerCase()){
      dispatch(setNotip(""))
      dispatch(setTipAdded(false))
    }
    dispatch(setSelectedDate(null))
    dispatch(isScheduleOrderPlaceOrder(false))
    setCartItem(true);
    navigate(`${basePath}/${type}`);
    const orderType = restaurantDetails?.orderTypes?.find((o: any) => {
      return (
        (type === 'Pickup' && o?.typeGroup === 'P') ||
        (type === 'Delivery' && o?.typeGroup === 'S')
      );
    })?.typeName;

    let payload = {
      type: orderType,
      locationId: restaurantDetails.id,
      customerId: customerId,
      searchText: null,
      visibleTo: "C",
      sagaSuccessCB: commonSuccess
    };

    dispatch(getRestaurantMenuDetails(payload));

    const currentOrderTypeId = restaurantDetails?.orderTypes?.find(
      (o: any) => o?.typeName === type
    )?.id;

    const cartItemObj = cartData?.map((item: any) => ({
      itemId: item?.itemId,
      modifierIds: item?.options?.map((modifier: any) => modifier?.typeId)
    }))

    const cartPayload = {
      itemIds: CartItemIds,
      itemObj: cartItemObj,
      orderTypeId: currentOrderTypeId,
      locationId: restaurantDetails?.id
    };

    dispatch(cartItemRequest(cartPayload));

    // Reset user selection when order type changes
    setHasUserMadeSelection(false);
    setIsAsapSelected(false);
    // navigate(`${basePath}/${type}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const selectedDate = useSelector((state: any) => state.cart?.selectedDate);

  const restaurantDefaultDeliveryEta = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail?.defaultDeliveryETA
  );
  const restaurantDefaultPickupEta = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail?.defaultPickUpETA
  );
  const restaurantDetail = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );
  const isDeliveryOrder = useSelector(
    (state: any) => state.cart.isDeliveryOrder
  );

  const isDeliveryOrderType = restaurantDetail?.orderTypes?.some((type: any) => {
    return type?.typeName === slugFromLocalStorage?.menuType && type?.typeGroup === 'S'
  });



  const useSelectedTab = () => {
    const location = useLocation();

    const selectedTab = useMemo(() => {
      const pathParts = location.pathname.split("/").filter(Boolean);
      const last = pathParts[pathParts.length - 1];
      const secondLast = pathParts[pathParts.length - 2];

      if (last === "exploremenu") return "explore";
      if (last === "restaurantinfo") return "restaurantinfo";
      if (last === "Reservation") return "reservation";
      if (last === "checkin") return "checkIn";

      if (secondLast === "menu") return "menu";
      if (last === "menu") return "menu";
      if (pathParts.length === 2 && pathParts[0] === "restaurant") return "menu";

      return "";
    }, [location.pathname]);

    return selectedTab;
  };


  const selectedTaboption = useSelectedTab();

  const getOpeningTimeWServiceWindow = () => {
    const restaurantDefaultEta = isDeliveryOrderForAddress
      ? restaurantDetails?.defaultDeliveryETA
      : restaurantDetails?.defaultPickUpETA;

    let baseTime = restaurantDetails?.timeZoneCd ? moment().tz(restaurantDetails?.timeZoneCd) : moment();

    if (restaurantDefaultEta) {
      baseTime = baseTime.add(restaurantDefaultEta, "minutes");
    }
    return baseTime.toDate();
  };


  
  const [selectDate, setSelectDate] = useState<Date | undefined>(selectedDate);

  const BothOrderTypeisnotAvailble = (PickupOrderType && !PickupOrderType[0]?.isEnabled) && (DeliveryOrderType && !DeliveryOrderType[0]?.isEnabled)

  const [isAsapSelected, setIsAsapSelected] = useState(false);
  const [hasUserMadeSelection, setHasUserMadeSelection] = useState(false);

  const userDetails: any = getCookie(USER_DETAILS)
  const currentUserDetail = useSelector((state: any) => state.user.currentUserDetail)
  const UpdateProfileSuccess = useSelector((state: any) => state.auth.UpdateProfileSuccess)
  const isRestaurantClosed = useSelector((state: any) => state.scheduler.restaurantClosed);
  const nextSesstionStartTime = restaurantDetail?.nextSession?.nextSessionStartTime

  const [userId, setuserId] = useState<string | null>(null)

  useEffect(() => {
    if(customerId){
      setuserId(customerId)
    } else {
      // Clear userId when customerId is empty (e.g., after 403)
      setuserId(null)
    }
  }, [customerId, UpdateProfileSuccess])
  
  // Keep selectDate in sync with selectedDate from Redux

  // Reset user selection when popup is opened for the first time.
 useEffect(() => {
  
      if (!selectDate && !selectedDate&& restaurantDetails?.id) {
         const currentMoment = new Intl.DateTimeFormat("en-CA", {
          timeZone: restaurantDetails?.timeZoneCd,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(new Date());
        setSelectDate(new Date(currentMoment));
        dispatch(setSelectedDate(new Date(currentMoment)));
      } else {
        setSelectedDate(selectedDate);
      }
    }, [restaurantDetails]);
  useEffect(() => {
    if (isAsapVisible && !isMobile && restaurantDetail?.id) {
      if (!hasUserMadeSelection) {
        // When popup opens for the first time, set default ASAP time
        const defaultAsapTime = getCurrentTimeASAP(
          isDeliveryOrderType,
          restaurantDefaultDeliveryEta || 0,
          restaurantDefaultPickupEta || 0,
          restaurantDetail?.timeZoneCd || '',
          isRestaurantClosed,
          nextSesstionStartTime
        );
        setSelectDate(new Date(defaultAsapTime?.restaurantDateTime));        
      } else {
        // If user has made a selection before, start with that selection        
        setSelectDate(selectedDate);
      }
    }
  }, [
    isAsapVisible, 
    hasUserMadeSelection, 
    isDeliveryOrderType, 
    restaurantDefaultDeliveryEta, 
    restaurantDefaultPickupEta, 
    restaurantDetail?.timeZoneCd, 
    selectedDate, 
    isRestaurantClosed,
  ]);

  // Reset user selection when component first loads or order type changes
  useEffect(() => {
    // Reset to show "Get it ASAP" by default
    setHasUserMadeSelection(false);
    setIsAsapSelected(false);
  }, [selectedDeliveryType]); // Reset when delivery type changes

  // useEffect(() => {
  //  if(!isMobile){
  //    const defaultAsapTime = getAsapTime(
  //     isDeliveryOrderType,
  //     restaurantDefaultDeliveryEta || 0,
  //     restaurantDefaultPickupEta || 0,
  //     restaurantDetail?.timeZoneCd || '',
  //     isRestaurantClosed,
  //     nextSesstionStartTime
  //   );
  //   if (selectedDate && new Date(selectedDate) >= new Date(defaultAsapTime)) {
  //     if (!hasUserMadeSelection) setHasUserMadeSelection(true)
  //     setSelectDate(selectedDate);
  //   }
  //  }
  //   //  else {
  //   //  const defaultAsapTime = getAsapTime(
  //   //     isDeliveryOrderType,
  //   //     restaurantDefaultDeliveryEta || 0,
  //   //     restaurantDefaultPickupEta || 0,
  //   //     restaurantDetail?.timeZoneCd || '',
  //   //   );
  //   //   // dispatch(setSelectedDate(defaultAsapTime))
  //   //   setSelectDate(defaultAsapTime);
  //   // }
  // }, [hasUserMadeSelection, selectedDate, isDeliveryOrderType, restaurantDefaultDeliveryEta, restaurantDefaultPickupEta, restaurantDetail?.timeZoneCd, isRestaurantClosed]);

  // Memoized ASAP time calculation using shared function
  // const asapTime = useMemo(() => {
  //   return getAsapTime(
  //     isDeliveryOrderType,
  //     restaurantDefaultDeliveryEta || 0,
  //     restaurantDefaultPickupEta || 0,
  //     restaurantDetail?.timeZoneCd || '',
  //     isRestaurantClosed,
  //     nextSesstionStartTime
  //   );
  // }, [isDeliveryOrderType, restaurantDefaultDeliveryEta, restaurantDefaultPickupEta, restaurantDetail?.timeZoneCd, isRestaurantClosed]);

  const handleCancel = (event: React.MouseEvent) => {
    setIsAsapVisible(false);
    // Reset selectDate to the original selectedDate when user cancels
    // This discards any temporary selections made in the popup
    setSelectDate(selectedDate);
    setIsAsapSelected(false);
    // Don't reset hasUserMadeSelection here - let the user keep their previous selection
  };
  const handleDateChange = (date: any) => {
    setSelectDate(date);
    // Check if the selected time matches ASAP time
    const isCurrentAsap = date && isAsapTime(
      date,
      isDeliveryOrderType,
      restaurantDefaultDeliveryEta || 0,
      restaurantDefaultPickupEta || 0,
      restaurantDetail?.timeZoneCd || ''
    );

    setIsAsapSelected(isCurrentAsap);
  };

  const handleApply = (date: any, timeSlot?: string) => {
    setSelectDate(date);
    dispatch(setSelectedDate(date));
    dispatch(setSelectedTimeSlot(timeSlot || ""))
    // Check if the selected time matches ASAP time
    const isCurrentAsap = date && isAsapTime(
      date,
      isDeliveryOrderType,
      restaurantDefaultDeliveryEta || 0,
      restaurantDefaultPickupEta || 0,
      restaurantDetail?.timeZoneCd || ''
    );

    setIsAsapSelected(isCurrentAsap);
    setHasUserMadeSelection(true);
    setIsAsapVisible(false);
  };

    useEffect(() => {
  
      if (!selectDate && !selectedDate&& restaurantDetails?.id) {
         const currentMoment = new Intl.DateTimeFormat("en-CA", {
          timeZone: restaurantDetails?.timeZoneCd,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(new Date());
        setSelectDate(new Date(currentMoment));
        dispatch(setSelectedDate(new Date(currentMoment)));
      } else {
        setSelectedDate(selectedDate);
      }
    }, [restaurantDetails]);
  

  useEffect(() => {
    if (!selectedDate && restaurantDetail?.id) {

      const currentDateTime = getCurrentTimeASAP(
        isDeliveryOrderType,
        restaurantDefaultDeliveryEta || 0,
        restaurantDefaultPickupEta || 0,
        restaurantDetail?.timeZoneCd || '',
        isRestaurantClosed,
        nextSesstionStartTime
      );
      //const currentDateTime = getCurrentTimeByTimezone(restaurantDetails?.timeZoneCd);
      
      setSelectDate(new Date(currentDateTime.restaurantDateTime));
      dispatch(setSelectedDate(new Date(currentDateTime.restaurantDateTime)));
    } else {
      setSelectedDate(selectedDate)

    }
  }, [restaurantDetails])

  const userName = (getCookie(USER_DETAILS) || {})?.firstName || "";
const isSchedularOrder = useSelector((state: any) => state.cart?.isScheduleOrder)



  useEffect(() => {
    if (selectedPop === "location") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedPop]);
  const userID = getCookie(USER_ID);



  useEffect(() => {
    if (isAsapVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isAsapVisible]);

  const eventNameFordisplay = useMemo(() => {
    if (!isEventOrder) return "";

    const formatted = isEventOrder?.replace(/-/g, " ")
    const displayName = formatted?.charAt(0)?.toUpperCase() + formatted?.slice(1)

    return displayName
  }, [isEventOrder])

  const ASAPTime = () => {
    // Check if the selected time matches ASAP time
    const isCurrentAsap = useMemo(() => {
      return selectedDate && isAsapTime(
        selectedDate,
        isDeliveryOrderType,
        restaurantDefaultDeliveryEta || 0,
        restaurantDefaultPickupEta || 0,
        restaurantDetail?.timeZoneCd || ''
      );

    }, [isDeliveryOrderType, restaurantDefaultDeliveryEta, restaurantDefaultPickupEta, restaurantDetail?.timeZoneCd, selectedDate])    

    const defaultAsapTime = useMemo(() => {
      return getAsapTime(
      isDeliveryOrderType,
      restaurantDefaultDeliveryEta || 0,
      restaurantDefaultPickupEta || 0,
      restaurantDetail?.timeZoneCd || '',
      isRestaurantClosed,
      nextSesstionStartTime
    );
    }, [nextSesstionStartTime, isRestaurantClosed, restaurantDefaultPickupEta, restaurantDetail, isDeliveryOrderType])
    // Show selected time only if user has explicitly made a selection and it's not ASAP
    // hasUserMadeSelection ensures we don't show any default/current time values
  const dateUtil = useMemo(() => {
    // Use selectedDate if available, otherwise fallback
    const dateMoment = selectedDate
      ? moment(selectedDate)
      : moment(defaultAsapTime).tz(restaurantDetails?.timeZoneCd);

    const localNow = moment();
    const localDate = localNow?.format("YYYY-MM-DD");
    const serverDate = dateMoment?.format("YYYY-MM-DD");

    // if (moment(localDate).isAfter(moment(serverDate))) {      
    //   dateMoment.add(1, "day");
    // }

    const day = dateMoment?.date();
    const month = dateMoment?.format("MMM"); // short month
    const hours = dateMoment?.hour();
    const minutes = dateMoment?.minute().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;

    return { day, month, formattedHours, minutes, ampm };
  }, [selectedDate, restaurantDetails?.timeZoneCd, defaultAsapTime, isRestaurantClosed]);

    return (
      <>
        {(hasUserMadeSelection && !!selectedDate && !isCurrentAsap && isSchedularOrder) ?
          <>
            <span className="getIn-text2">{`${dateUtil?.day} ${dateUtil?.month},`}</span>
            <span className="getIn-text2">{`${dateUtil?.formattedHours}:${dateUtil?.minutes} ${dateUtil?.ampm}`}</span>
          </> : <>
            {/* // Always show "Get it ASAP" if user hasn't made a selection or if ASAP is selected */}
            <span className="getIn-text1">Get it</span>
            <span className="getIn-text2">ASAP</span>
          </>}
      </>)
  }
  return (
    <>
     <Helmet>
        <title>{restaurantDetails?.seo?.metaTitle}</title>
        <meta name="description" content={restaurantDetails?.seo?.metaDescription} />
        <meta name="keywords" content={restaurantDetails?.seo?.metaKeywords} />
        <meta name="robots" content={restaurantDetails?.seo?.metaTags} />
        <meta name="canonical" content={restaurantDetails?.seo?.metaCanonical} />
        <meta name="author" content={restaurantDetails?.seo?.metaAuthor} />
        <meta name="image" content={restaurantDetails?.seo?.metaImage} />
      </Helmet>
      <div
        className={
          isAccountPage
            ? "menu-page-header-desktop"
            : "menu-page-header-desktop"
        }
      >

        {
          !shouldNotShowBackbtn && <>
            {isAccountPage || TrackingPage ? (
              <div>
                <img
                  src={accountsBack}
                  alt="accountsBack"
                  title="Back"
                  className="accountsBack"
                  onClick={() => navigate(-1)}
                />
              </div>
            ) : (
              <HomeIcon
                className="homePageIcon-new"
                style={{ width: "37px", height: "37px" }}
                onClick={() => {
                  setShowMenuDrawer(true);
                  // if (setPaymentStatus) setPaymentStatus(true);
                }}
              />
            )}
          </>
        }


        <div
          className={
            isAccountPage
              ? "restaurant-logo-container-desktop-account"
              : "restaurant-logo-container-desktop"
          }
          style={{ marginLeft: shouldNotShowBackbtn ? "43%" : "" }}
        >
          {getImageURL("LOGO") && (
            <img
              src={getImageURL("LOGO")}
              alt="logo"
              title="Restaurant Logo"
              className="restaurant-logo-new-desktop"
            />
          )}
          <span className="restaurant-branchName-desktop">
            {/* <p
              className={isAccountPage ? "branchName-accountspage-header" : ""}
            >
              {restaurantDetails.branchName.split(",")[0]}
            </p> */}
            <h1
              // className={
              //   isAccountPage ? "restaurantName-accountspage-header" : ""
              // }
              className="restaurantName-accountspage-header"
            >
              {restaurantDetails.branchName.split(",")[1]}
            </h1>
            <p
              // className={
              //   isAccountPage ? "restaurantName-accountspage-state" : ""
              // }
              className="restaurantName-accountspage-state"
            >
              {restaurantDetails.state}
            </p>
          </span>
        </div>

        {Switch && <div className="divider-line-desktop-header" />}
        {Switch && (
          <div>
            <>

              <div className="toggle-container-desktop">
                <button
                  className={` ${selectedDeliveryType === "Pickup" ? "active" : ""
                    } 
                    
                     (${(BothOrderTypeisnotAvailble) || (PickupOrderType && !PickupOrderType[0]?.isEnabled) ? "" : ""})
                    
                    
                    `}
                  style={{
                    cursor: "pointer"
                    // (PickupOrderType && PickupOrderType[0]?.isEnabled) ? "pointer" : "default" 

                  }}
                  disabled={isEventDate}
                  onClick={() => {
                    // if (selectedDeliveryType !== "Pickup" && PickupOrderType[0]?.isEnabled) {
                    //   TogglleClick("Pickup");
                    // }

                    TogglleClick("Pickup");

                  }}
                >
                  {isEventDate ? `${eventNameFordisplay} (Pickup)` : "Pickup"}

                </button>
                {isEventDate ? null :
                  <button
                    className={` ${selectedDeliveryType === "Delivery" ? "active" : ""
                      } 
                      
                       ${((BothOrderTypeisnotAvailble) || (DeliveryOrderType && !DeliveryOrderType[0].isEnabled)) ? "" : ""} 
                      
                      `}
                    style={{
                      cursor: "pointer"

                      // (DeliveryOrderType && DeliveryOrderType[0]?.isEnabled) ? "pointer" : "default" 
                    }}

                    onClick={() => {
                      // if (selectedDeliveryType !== "Delivery" && DeliveryOrderType[0]?.isEnabled) {
                      //   TogglleClick("Delivery");
                      // }
                      TogglleClick("Delivery");
                    }}
                  >
                    Delivery
                  </button>
                }
              </div>
            </>
          </div>
        )}

        {Switch && !isEventDate && (
          <div>
            <div
              className="getIn-Container"
              onClick={() => setIsAsapVisible(true)}
            >
              <p className="getIn-text">
                <ASAPTime />
              </p>
              <img src={calendar} alt="calendar" className="ASAP-img" title="Calendar" />
            </div>
          </div>
        )}


        {Switch && (
          <>
            {customerId && selectedDeliveryType === "Delivery" && (
              <div
                className="header-location-container"
                onClick={() => {
                  setSelectedPop("location")
                  dispatch(viewDeliveryAddressRequest());
                }}
              >
                <Maps className={"Location-icon-d"} />

                {/* <img src={map} alt="map" title="Location" /> */}
                <div className="header-address">
                  {selectedDeliveryAddress?.addressLine1
                    ? selectedDeliveryAddress?.addressLine1
                    : "Select Delivery address"}
                </div>
              </div>
            )}
          </>
        )}
        {Switch && <div className="divider-line-desktop-header headerLinks-divider" />}
        {Switch && (
          <>
            <p
              className={`headerLinks ${selectedTaboption === "restaurantinfo" ? "active" : ""
                }`}
              onClick={() => {
                dispatch(toggleClick());
                handleTabClick("restaurantInfo")
                navigate(
                  `${cleanedPath(window.location.pathname, !!(itemName || ""))}/restaurantinfo`
                )
              }
              }
            >
              Restaurant Info
            </p>
            {groupMenuExploreItems(dishes).length > 0 && (
              <p
                className={`headerLinks ${selectedTaboption === "explore" ? "active" : ""
                  }`}
                onClick={() => {
                  dispatch(toggleClick());
                  handleTabClick("explore")
                  navigate(
                    `${cleanedPath(window.location.pathname, !!(itemName || ""))}/exploremenu`
                  )
                }
                }
              >
                Explore
              </p>
            )}

            <p
              className={`headerLinks ${selectedTaboption === "menu" ? "active" : ""
                }`}
              // onClick={() => handleTabClick("menu")}
              onClick={() => {
                dispatch(toggleClick());
                handleTabClick("menu");

                if (eventDate) {
                  navigate(
                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${selectedDeliveryType}/event/${eventDate}`
                  )
                } else {
                  navigate(
                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${selectedDeliveryType}`
                  )
                }
              }
              }
            >
              Full Menu
            </p>


            <p
              className={`headerLinks ${selectedTaboption === "reservation" ? "active" : ""
                }`}
              onClick={() => {
                dispatch(reservatonMenuApiCall());
                navigate(
                  `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/Reservation`
                )
              }}
            >
              Reservation
            </p>
            <p
              className={`headerLinks ${selectedTaboption === "checkIn" ? "active" : ""
                }`}
              onClick={() => {
                dispatch(reservatonMenuApiCall());
                navigate(
                  `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/checkin`
                )
              }}
            >
              Check In
            </p>
          </>
        )}

        {Switch && <div className="divider-line-desktop-header" />}
        {/* selectedDeliveryType === "Delivery" */}
        {!TrackingPage && 
        cartData?.length > 0 && ( 
        ((selectedDeliveryType === "Delivery" &&(DeliveryOrderType[0]?.isEnabled)) || 
        (selectedDeliveryType === "Pickup" && (PickupOrderType[0]?.isEnabled))) || (eventName && eventName !== '')) ? (

          <div
            className={`cart-header ${cartData?.length > 0 ? "active" : ""}`}
            onClick={toggleCart}
          >
            {
              <>
                <span>{cartData?.length}</span>
                <CartIcon />
              </>
            }
          </div>
        ) :
          <div className="cart-header"></div>
        }

        {(Switch || TrackingPage) && (
          <div>
            <div className="userIcon-container">
              {(TrackingPage
                ? ((userDetails !== null && Object.keys(userDetails).length > 0) || currentUserDetail?.firstName || userId)
                : (customerId || currentUserDetail?.firstName || userId) && !tableId) ? (
                <div className="active-user-withname">
                  <ActiveUser
                    onClick={handleLogoutclick}
                    className="active-user-icon-new"
                  />
                  <p className="loginText-D">{userName}</p>
                </div>
              ) : (
                <>
                  <img
                    src={tableId ? checkOutBell : userIcon}
                    alt="userIcon"
                    title="User Icon"
                    className="user-icon-new"
                    onClick={() => {
                      if (
                        tableId &&
                        (orderDetails || (orderInfo && orderInfo?.length > 0))
                      ) {
                        navigate(
                          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${tableId}/order/${orderInfo[0]?.orderId}`
                        );
                      }
                      if (!tableId) {
                        // When manually opening, reset global trigger flag first
                        setIsGlobalTriggered(false);
                        // Set local state first, then global state
                        setShowSignUpPopup(true);
                        // Small delay to ensure local state is set before global
                        setTimeout(() => {
                          dispatch(setSignupPopupAction(true));
                        }, 0);
                      }
                    }}

                  />
                  <p className="loginText">{'Login'}</p>
                  {cdOrdersItems?.length > 0 && (
                    <div className="CD-orderCount">{cdOrdersItems?.length}</div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Only show local Signupnew if it's manually triggered (not from global 403/401) */}
      {showSignUpPopup && !isGlobalTriggered && (
        <Signupnew
          isOpen={showSignUpPopup}
          signInPopupDesktop={true}
          onClose={() => {
            setShowSignUpPopup(false);
             dispatch(routeToLogin(false));
            dispatch(setSignupPopupAction(false));
          }}
        />

      )}

      {isAsapVisible ? (
        <div className="header-delivery-container">
          <div className="header-delivery-containe-popup-content" style={{ width: "677px" }}>
            <div className="asap-container">
              <div>
                <h4>{selectedDeliveryType === "Pickup" ? "Pick-Up" : "Delivery"} Date & Time </h4>
                {isEventOrders ? null : <>
                  <p className="asap-container-header">
                    Earliest possible {selectedDeliveryType === "Pickup" ? "pick-Up" : "delivery"} Time <b>{formatDate(selectDate, null,restaurantDetails?.timeZoneCd)} </b>{" "}<p>{restaurantDetails?.timeZone}</p></p>
                  {/* <p>If you need it to be {selectedDeliveryType === "Pickup" ? "picked up" : "delivered"} later, please adjust the timing.</p> */}
                  <p>Changed your plans? Adjust the timing here  </p>
                </>}
              </div>
              <PickDateSelectionDesktop onClose={handleCancel} selectDate={selectDate} handleDateChange={handleDateChange} handleApply={handleApply} asapFlow={true} />
            </div>
          </div>
        </div>
      ) : null}

      {switchingOrderType && cartData?.length > 0 && (
        <SwitchingorderType
          isOpen={switchingOrderType}
          onClose={() => {
            setSwitchingOrderType(false);
          }}
          onToggle={TogglleClick}
          type={orderType}
          currentOrdertypeDetails={currentOrdertypeDetails}
        />
      )}

      {selectedPop === "location" && (
        <div className="header-delivery-container">
          <div className="header-delivery-containe-popup-content">
            <CancelIcon
              className="closeBtn-delivery-menuPage"
              onClick={() => handelClosePopUp()}
            />
            <div className="delievry-details-style-desktop">
              <DeliveryDetails
                handleDeliveryFormSubmit={handleDeliveryFormSubmit}
                addresses={DeliveryAddress}
                handleDeleteAddress={onDeleteAddress}
                handleAddressFieldOnChange={handleAddressFieldOnChange}
                onAddressSelect={onAddressSelect}
                selectedAddressesId={selectedAddresses}
                isDesktop={true}
                onClose={handelClosePopUp}
              />
              <button
                className="switching-order-type-button"
                onClick={handelClosePopUp}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DesktopHeader;
